export const en = {
    'error-add': 'Error! Failed to add product',
    'success-add': 'Product added successfully'
};
